<!-- ADD USER MODAL START-->
<form [formGroup]="commonForm" (ngSubmit)="onSubmit()" id="trade-register-form"
      (keydown.enter)="$event.preventDefault()">
  <div class="loader-parent">
    <!-- Modal Header -->
    <div class="modal-header">
      <h4 class="modal-title">{{ MainModule }}</h4>
    </div>

    <!-- Modal Body -->
    <div class="modal-body">
      <div class="add-user-form">
        <div class="row">
          <div class="col">
            <label class="grey-label">
              {{ fieldData.label }}
              <span class="required-field" *ngIf="fieldData.validation?.required">*</span>
            </label>
            <input class="form-control" [ngClass]="{
                'is-invalid':
                  !closing &&
                  ((commonForm.controls['field'].invalid &&
                    commonForm.controls['field'].touched) ||
                  submitted ||
                  uf.field.errors?.apiError),
                'is-valid': !commonForm.controls['field'].invalid
              }"
              formControlName="field"
              type="text"
              [attr.inputmode]="isNumber ? 'numeric' : null"
              (keypress)="onKeyPress($event) || $event.preventDefault()"
              placeholder="{{ fieldData.placeholder ? fieldData.placeholder : 'Enter ' + (fieldData.label ? fieldData.label.substr(0).toLowerCase() : '') }}" />
            <span class="invalid-feedback" role="alert"
                  *ngIf="!closing && (uf.field.invalid && (uf.field.touched || submitted))">
              <span *ngIf="uf.field.errors?.required && !uf.field.errors?.whitespace">
                {{ fieldData.validation.message }}
              </span>
              <span *ngIf="uf.field.errors?.whitespace">
                Only blank spaces are not allowed.
              </span>
              <span *ngIf="uf.field.errors?.pattern">
                Enter a whole number.
              </span>
              <span *ngIf="uf.field.errors?.min">
                {{ fieldData.label }} cannot be less than {{ fieldData.validation.min }}.
              </span>
              <span *ngIf="uf.field.errors?.max">
                {{ fieldData.label }} cannot be more than {{ fieldData.validation.max }}.
              </span>
            </span>
            <span class="invalid-feedback d-block" role="alert" *ngIf="!closing && uf.field.errors?.apiError">
              {{ uf.field.errors?.apiError }}
            </span>
            <span class="field-hint" *ngIf="fieldData.hint">{{ fieldData.hint }}</span>
          </div>
        </div>
      </div> <!-- Close add-user-form -->
    </div> <!-- Close modal-body -->

    <!-- Modal Footer -->
    <div class="modal-footer">
      <button type="button" class="dark-bordered-btn" data-dismiss="modal" #closeBtn
              (mousedown)="$event.preventDefault()" (click)="close()">
        Close
      </button>
      <button type="submit" class="submit-btn-grey create-user-btn">
        Save
      </button>
    </div>
  </div> <!-- Close loader-parent -->
</form>
<!-- ADD USER MODAL END-->
